import { useEffect } from 'react';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';
import { getRelatedTo, getFilter } from '#component/general/list-filter/helper';
import { setFilterPristine } from '#action/list-filter';
import { deepEqualWithoutOrder } from '#helper';

export const useFilterPristine = () => {
  const dispatch = useDispatch();
  const relatedTo = getRelatedTo();
  const filter = useSelector(s => s.listFilter, shallowEqual);
  const initial = getFilter(filter?.initial?.[relatedTo]);
  const current = getFilter(filter[relatedTo]);
  const isPristine = deepEqualWithoutOrder(initial, current);

  useEffect(() => {
    dispatch(setFilterPristine(isPristine));
  }, [dispatch, isPristine, current]);
};
